webpackJsonp([53281529457051],{

/***/ 1856:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"MedicationIntegrationTransactionConnection","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"edges","type":{"kind":"LIST","name":null,"ofType":{"kind":"OBJECT","name":"MedicationIntegrationTransactionEdge","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"pageInfo","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"OBJECT","name":"PageInfo","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-medication-integration-transaction-connection-f7c55904cab18cffd0ef.js